import React from 'react';
import styled from 'astroturf/react';
import { TimesIcon } from 'js/social/shared/Icons';

const Container = styled.div`
  position: relative;
`;

const RemoveButton = styled.div`
  @import 'stylesheets/design_system/font';
  @include body__small-bold;

  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
  color: white;
  cursor: pointer;
  border-radius: 4px;
  background-color: rgb(34 34 51 / 0.7);
`;

type Props = {
  onRemove: () => void;
  className?: string;
  removable?: boolean;
};

export const AttachmentOverlay: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  children,
  onRemove,
  removable = true,
}) => {
  return (
    <Container className={className}>
      {children}

      {removable && (
        <RemoveButton
          onClick={(event) => {
            event.preventDefault();
            onRemove();
          }}
        >
          <TimesIcon />
          Remove
        </RemoveButton>
      )}
    </Container>
  );
};
